/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeWhiteNote } from "./d-theme-white-note";

export class DThemeWhiteNoteSmall extends DThemeWhiteNote {
	getFontSize(): number {
		return 18;
	}
}
